<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Transfer Inventory to a Project</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="field">
            <label class="label">Project</label>
            <span>{{ projectInventory.project.project_name }}</span>
          </div>

          <div class="field">
            <label class="label">Product Being Transferred</label>
            <span>{{ projectInventory.inventory.product_master.name }}</span>
          </div>

          <div class="field">
            <label class="label">Quantity Available</label>
            <span>{{ projectInventory.qty_available -  transferring.qty}}</span>
          </div>

          <div class="field">
            <label class="label">Transfer To Project*</label>
            <v-select
              required
              :options="projects"
              item-text="project_name"
              item-value="id"
              v-model="transferring.to_project_id"
            />
          </div>

          <div class="field">
            <label class="label">Transfer Quantity*</label>
            <v-text-field
              required
              placeholder="Enter Transfer Quantity"
              type="number"
              :rules="transferQtyRules"
              v-model="transferring.qty">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="transfer()">
            Confirm Transfer
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    projectInventory: {
      type: Object
    }
  },
  components: { 
    VForm,
    VTextField,
    VSelect
  },
  data() {
    return {
      transferring: {
        to_project_id: null,
        qty: null
      },
      valid: false
    }
  },
  computed: {
    ...mapState("projects", ["projects"]),
    transferQtyRules() {
      return [
        (v) => v <= this.projectInventory.qty_available || 'Transfer quantity cannot be greater than quantity available'
      ]
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("projects", ["getProjects"]),
    ...mapActions("inventoryProject", ["transferToProject"]),
    initialize() {
      if (this.projects.length == 0) {
        this.getProjects({ per_page: 1000 });
      }
    },
    transfer() {
      this.transferToProject({
        from_project_id: this.projectInventory.project.id,
        to_project_id: this.transferring.to_project_id,
        stocking_unit_id: this.projectInventory.inventory.stocking_unit_id,
        qty: this.transferring.qty
      }).then(() => this.close(true))
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
